// Diagnóstico do cliente (01/11/2026): the interviews and the model questions that guide the consultant.
export default {
  diagnoses: {
    tab: 'Diagnóstico',
    new: 'Novo diagnóstico',
    empty: 'Nenhum diagnóstico ainda.',
    emptyText: 'Cada diagnóstico é uma conversa com alguém de uma área do cliente. Comece pelo primeiro.',
    topics: 'Nenhum tópico | 1 tópico | {n} tópicos',
    by: 'por {name}',
    noInterviewee: 'Sem entrevistado',
    // The new interview.
    dialogTitle: 'Novo diagnóstico',
    area: 'Área',
    areaPlaceholder: 'Ex.: Financeiro',
    areaHint: 'Livre: use os nomes de áreas deste cliente.',
    interviewee: 'Quem foi entrevistado',
    otherPerson: 'Outra pessoa (digitar o nome)',
    nobody: 'Ainda não sei',
    intervieweeName: 'Nome e cargo',
    intervieweeNamePlaceholder: 'Ex.: Tatiane, financeiro',
    heldOn: 'Data',
    create: 'Começar',
    // The interview screen.
    page: {
      back: 'Voltar ao cliente',
      notes: 'Anotações',
      notesHint: 'Um tópico por linha, como no caderno. Enter abre o próximo; apagar uma linha vazia remove o tópico.',
      placeholder: 'O que a pessoa contou…',
      add: 'Adicionar tópico',
      remove: 'Remover o tópico',
      internal: 'Interno',
      internalHint: 'Fica só com a equipe: nunca vai para o cliente.',
      questions: 'Perguntas modelo',
      questionsHint: 'Para guiar a conversa. Marque as que já fez.',
      forEveryArea: 'Para toda área',
      forArea: 'Para {area}',
      noAreaMatch: 'Sem perguntas próprias para esta área: use as gerais.',
      saving: 'Salvando…',
      saved: 'Salvo',
      saveFailed: 'Não foi possível salvar. Tentando de novo ao editar.',
      delete: 'Excluir diagnóstico',
      deleteTitle: 'Excluir este diagnóstico?',
      deleteText: 'As anotações desta conversa se perdem. Esta ação não pode ser desfeita.',
      deleted: 'Diagnóstico excluído.',
      notFound: 'Diagnóstico não encontrado',
      notFoundText: 'Ele pode ter sido excluído.',
    },
    // Etapa 2: the findings.
    views: { interviews: 'Entrevistas', findings: 'Achados', plan: 'Priorização' },
    // Etapa 3: the plan (the columns of the spreadsheet).
    plan: {
      intro: 'Para cada achado: o projeto que resolve, o impacto, a complexidade e a prioridade combinada com os donos. A classificação sai do impacto × complexidade, mas você pode escolher outra.',
      suggest: 'Sugerir com IA',
      suggesting: 'Sugerindo {area}… ({n} de {total})',
      suggested: 'Sugestões preenchidas nos campos vazios. Revise e combine a prioridade com os donos.',
      suggestedPartial: 'Sugerido, menos: {areas}. Tente de novo.',
      pdf: 'Baixar PDF',
      empty: 'Sem achados para priorizar.',
      emptyText: 'Gere ou escreva os achados primeiro, na visão Achados.',
      groups: {
        quick_win: 'Quick Wins',
        structuring: 'Projetos estruturantes',
        complementary: 'Melhorias complementares',
        none: 'A classificar',
      },
      groupHints: {
        quick_win: 'Alto impacto e implantação rápida: por onde começar.',
        structuring: 'Mudam a gestão ou a operação; pedem mais tempo e envolvimento.',
        complementary: 'Ganhos menores, que entram conforme a capacidade.',
        none: 'Preencha impacto e complexidade, ou escolha a classificação.',
      },
      project: 'Projeto sugerido',
      projectPlaceholder: 'Ex.: Relatório de clientes sem compra por 30/60/90 dias',
      impact: 'Impacto',
      complexity: 'Complexidade',
      classification: 'Classificação',
      priority: 'Prioridade',
      note: 'Observação',
      auto: 'Automática ({value})',
      autoEmpty: 'Automática',
      levels: { high: 'Alto', medium: 'Médio', low: 'Baixo' },
      levelsF: { high: 'Alta', medium: 'Média', low: 'Baixa' },
      none: '—',
      createProject: 'Criar projeto',
      createProjectTitle: 'Criar o projeto "{title}"?',
      createProjectText: 'Um projeto novo do cliente, "Não iniciado", com este achado como objetivo. Você completa o resto na tela do projeto.',
      projectCreated: 'Projeto {code} criado.',
      openProject: 'Projeto {code}',
      saveFailed: 'Não foi possível salvar esta linha.',
    },
    findings: {
      title: 'Achados',
      intro: 'O que as entrevistas dizem, por área. A IA junta o que pessoas diferentes falaram; você revisa. Tópicos internos nunca entram.',
      generate: 'Gerar achados com IA',
      regenerate: 'Gerar de novo',
      regenerateArea: 'Gerar esta área de novo',
      new: 'Novo achado',
      empty: 'Nenhum achado ainda.',
      emptyText: 'Com as entrevistas feitas, a IA lê os tópicos área por área e sugere os achados. Você também pode escrever os seus.',
      noInterviews: 'Faça as entrevistas primeiro: os achados saem dos tópicos delas.',
      noAi: 'A IA não está disponível neste ambiente: escreva os achados à mão.',
      generating: 'Gerando {area}… ({n} de {total})',
      merging: 'Juntando o que se repete entre as áreas…',
      generated: 'Achados gerados. Revise cada um antes de seguir.',
      generatedPartial: 'Gerado, menos: {areas}. Tente essas áreas de novo.',
      merged: 'Nenhum repetido entre as áreas. | 1 achado repetido foi juntado. | {n} achados repetidos foram juntados.',
      regenerateTitle: 'Gerar os achados de novo?',
      regenerateText: 'Os achados de todas as áreas serão substituídos pelos da IA, inclusive os que você editou ou escreveu e a priorização deles. Os que já viraram projeto ficam.',
      regenerateAreaTitle: 'Gerar {area} de novo?',
      regenerateAreaText: 'Os achados desta área serão substituídos pelos da IA, inclusive os que você editou ou escreveu e a priorização deles. Os que já viraram projeto ficam.',
      areaStats: 'Nenhuma entrevista | 1 entrevista | {n} entrevistas',
      areaTopics: 'Nenhum tópico | 1 tópico | {n} tópicos',
      mentioned: 'Citado por {n} pessoa | Citado por {n} pessoas',
      sources: 'Ver os tópicos ({n})',
      hideSources: 'Esconder os tópicos',
      noName: 'Sem nome',
      edited: 'Editado',
      edit: 'Editar achado',
      remove: 'Excluir achado',
      removeTitle: 'Excluir este achado?',
      removeText: 'Os tópicos dele voltam para "sem achado".',
      removed: 'Achado excluído.',
      saved: 'Achado salvo.',
      uncovered: 'Tópicos ainda sem achado ({n})',
      uncoveredHint: 'O que as entrevistas trouxeram e ainda não está em nenhum achado.',
      fromTopic: 'Criar achado',
      // The dialog.
      dialogNew: 'Novo achado',
      dialogEdit: 'Editar achado',
      area: 'Área',
      findingTitle: 'Achado',
      findingTitlePlaceholder: 'Ex.: O fluxo de caixa é montado à mão todo dia',
      detail: 'Explicação',
      detailPlaceholder: 'Em uma a três frases, o que acontece e por que importa.',
      kind: 'Tipo',
      noKind: 'Sem tipo',
      numbers: 'Números citados',
      numbersHint: 'Um por linha, como foram ditos.',
      topics: 'Tópicos das entrevistas',
      topicsHint: 'Os que sustentam o achado. Quem falou cada um conta no "citado por".',
      noTopics: 'Nenhum tópico disponível.',
    },
    kinds: { pain: 'Dor', fact: 'Número', idea: 'Ideia', system: 'Sistema', bottleneck: 'Gargalo', action: 'Ação' },
    groups: {
      geral: 'Toda área',
      comercial: 'Comercial',
      financeiro: 'Financeiro',
      logistica: 'Logística',
      operacao: 'Operação e estoque',
      compras: 'Compras e importação',
      fiscal: 'Fiscal',
      contabil: 'Contábil',
      rh: 'Pessoas',
      marketing: 'Marketing',
      qualidade: 'Qualidade e produto',
      ti: 'Dados e tecnologia',
      diretoria: 'Diretoria',
      faturamento: 'Faturamento',
    },
    // The model questions, from what worked in the interviews of the first diagnoses.
    questions: {
      geral: {
        sistemas: 'Quais sistemas e ferramentas você usa no dia a dia?',
        foraDoSistema: 'O que você faz fora do sistema: em planilha, e-mail ou WhatsApp?',
        tempo: 'Quanto tempo isso leva por dia ou por semana?',
        relatorio: 'Que relatório ou número você monta à mão? Para quem?',
        outraArea: 'O que você espera de outra área, e quanto demora para chegar?',
        naoUsado: 'O que já existe no sistema e ninguém usa? Por quê?',
        numero: 'Qual é o número? Volume, R$, erros, clientes.',
        dependeDeAlguem: 'Isso depende de alguém específico para andar?',
        chegaTarde: 'Que informação chega tarde ou de surpresa?',
        quemDescobre: 'Quando dá errado, quem descobre primeiro: vocês ou o cliente?',
        ganho: 'Se isso fosse resolvido, quanto economizaria de tempo ou dinheiro?',
        prioridade: 'Das suas dores, qual é a primeira? E a segunda?',
      },
      comercial: {
        pedidos: 'Como os pedidos chegam (representantes, site, WhatsApp) e quem digita no sistema?',
        carteira: 'Vocês sabem quem parou de comprar e há quanto tempo?',
        base: 'Dos clientes cadastrados, quantos compraram no último mês?',
        atividade: 'O que se cobra do vendedor: só o faturamento ou também as ações (contatos, visitas, prospecção)?',
        prospects: 'Os prospects ficam registrados no sistema? Quantos ficam sem retorno?',
        materiais: 'O vendedor encontra rápido a ficha técnica, o catálogo e o material por tipo de cliente?',
        posVenda: 'Quanto do dia vai para o pós-venda (entrega, atraso, cobrança) em vez de vender?',
        leitura: 'Antes de falar com o cliente, dá para ver o histórico, o porte e o que ele compra?',
      },
      financeiro: {
        fluxo: 'Como o fluxo de caixa é montado, e quanto tempo leva?',
        conciliacao: 'Como é feita a conciliação bancária? Quantos bancos e contas?',
        cobranca: 'Como é feita a cobrança de quem está atrasado?',
        credito: 'Como são a análise de crédito e o limite? Cliente em protesto fica bloqueado?',
        recebiveis: 'Duplicatas, cartão e link de pagamento dão baixa sozinhos no sistema?',
        comissoes: 'Como as comissões são calculadas e enviadas?',
        confianca: 'Vocês confiam nos números do sistema ou conferem por fora?',
      },
      logistica: {
        rastreio: 'Como vocês sabem onde está cada entrega?',
        atraso: 'Quando atrasa, quem avisa o cliente, e quando?',
        frete: 'Como as tabelas de frete são cadastradas e conferidas com a fatura da transportadora?',
        prazo: 'Quantas notas são entregues fora do prazo por mês?',
        transportadora: 'O que acontece quando a transportadora não cumpre o combinado?',
        relatorios: 'Que relatórios diários são montados à mão (atrasos, cubagem, carregamento)?',
      },
      operacao: {
        localizacao: 'Como se encontra um produto no estoque? Existe endereçamento ou WMS?',
        separacao: 'Como são a separação e a conferência antes de carregar? Que erros acontecem?',
        capacidade: 'Quanto se expede por dia, e quanto daria com a operação organizada?',
        devolucao: 'Quantas devoluções vêm de erro de separação ou de etiqueta?',
        espaco: 'Falta espaço para armazenar ou separar?',
        prioridade: 'Os clientes prioritários chegam com antecedência para a operação?',
      },
      compras: {
        processo: 'As compras são feitas dentro do sistema ou em planilha?',
        decisao: 'Como se decide o que e quanto comprar? Usam giro, cobertura e sazonalidade?',
        ruptura: 'Vocês sabem quais produtos importantes estão para faltar?',
        excesso: 'Quanto dinheiro está parado em estoque que gira pouco?',
        negociacao: 'Como vocês se preparam para negociar com os fornecedores?',
        custo: 'O custo do produto está no sistema?',
      },
      fiscal: {
        entrada: 'Como as notas recebidas entram no sistema? Quem classifica?',
        conferencia: 'Como conferem se o sistema calculou o imposto certo? Quanto dá diferença?',
        mudancas: 'Como ficam sabendo das mudanças tributárias (NCM, regime do cliente)?',
        rastreio: 'Dá para saber quem mudou uma regra fiscal no sistema, e quando?',
      },
      contabil: {
        conciliacao: 'Como o contábil confere financeiro, compras e faturamento com o razão?',
        fechamento: 'Em que dia o mês fecha, e o que atrasa o fechamento?',
        planilhas: 'Que planilhas de conferência existem fora do sistema?',
      },
      rh: {
        folha: 'Como folha, ponto e holerite chegam às pessoas?',
        controles: 'Faltas, atestados, férias e benefícios: onde são controlados?',
        onboarding: 'Como é a integração de quem entra? A pessoa entende a empresa toda?',
        liderancas: 'Os líderes têm metas, feedback e rituais com a equipe?',
        contratacao: 'O que dificulta contratar?',
      },
      marketing: {
        objetivo: 'Qual é o objetivo do marketing, e quem define as prioridades?',
        leads: 'De onde vêm os leads, e eles são o público que vocês querem?',
        resultado: 'Quanto se investe em mídia, e como se mede o retorno?',
        estoque: 'O marketing sabe o que tem em estoque para fazer campanha?',
        ferramentas: 'Que ferramentas usam (e-mail, redes, site), e o que não funciona?',
      },
      qualidade: {
        cadastro: 'O cadastro do produto, a ficha técnica e o catálogo batem entre si?',
        informacao: 'Quando nasce um produto novo, a informação chega completa a quem precisa?',
        reclamacoes: 'Como chegam e são classificadas as reclamações e devoluções?',
        conhecimento: 'O conhecimento técnico está com quem? Está escrito ou gravado?',
      },
      ti: {
        sistemas: 'Quais sistemas existem, e eles conversam entre si?',
        acesso: 'Quem tem acesso ao banco de dados? Existe BI?',
        confianca: 'As áreas confiam nos dados do sistema?',
        modulos: 'Que módulos foram comprados e não são usados?',
        automacao: 'Que tarefa repetitiva alguém faz toda semana copiando, colando ou conferindo?',
      },
      diretoria: {
        indicadores: 'Que números vocês olham toda semana, e de onde eles vêm?',
        decisao: 'O que depende de vocês para ser decidido ou validado?',
        dores: 'Na visão de vocês, quais são os três maiores problemas da empresa?',
        comeco: 'Por onde vocês acham que devemos começar, e por quê?',
        canal: 'Por onde preferem receber os números: e-mail, WhatsApp, painel?',
      },
      faturamento: {
        rotina: 'Como é a rotina de emissão de notas e boletos? Quantas por dia?',
        etapas: 'Que etapas manuais existem entre faturar, imprimir e liberar a carga?',
        decisoes: 'Que decisões manuais são tomadas todo dia (ex.: o banco do boleto)?',
      },
    },
  },
}
